import { px2rem, SkeletonBox } from "@moim/common";
import styled from "styled-components";

export const BadgeSkeleton = styled(SkeletonBox).attrs({
  width: "100%",
  height: px2rem(180),
})``;
